/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2016, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/dashboard-common/dist/core/Collection',
	'./ConditionalStyle'
],
function(Collection, ConditionalStyle) {

	/**
	 * Collection which holds onto Dataset models
	 */
	var ConditionalStyleCollection = Collection.extend({

		// The class of objects that this collection manages
		modelClass: ConditionalStyle,

		init: function(models, options) {
			ConditionalStyleCollection.inherited('init', this, [models, options]);
		},

		getColor: function(index) {
			return index < this.size() ? this.getModels()[index] : null;
		},

		getColors: function() {
			return this.getModels();
		}
	});

	return ConditionalStyleCollection;
});
